<div id="appointmentInvitationDialog" class="modal-overlay active">
  <div class="modal-panel white">
    <div class="modal-header">
      <h1>
        <span class="status-modal-left">
          {{ 'agent:popin.invite_appointment_participant.title' | translate }}
        </span>
      </h1>
      <button class="close-modal animate-hide" (click)="cancel()">
        <span class="nodisplay">
          {{ 'commons:basic.closePopup' | translate }} "{{ 'agent:popin.invite_appointment_participant.title' | translate }}"
        </span>
      </button>
    </div>
    <ng-container
      *ngIf="{
        availableSkills: availableSkills$ | async,
        availableTeams: availableTeams$ | async,
        availableGroups: availableGroups$ | async,
        availableCsr: availableCsr$ | async
      } as data"
    >
      <div class="modal-body">
        <div class="invitation-request">
          <div class="invitation-form">
            <div class="invitation-field">
              <cng-appointment-target-form
                (eventTargetChange)="onTargetSelected($event)"
                (eventUpdateCandidateCsr)="updateCandidateCsr($event)"
                [csrs]="data.availableCsr"
                [groups]="data.availableGroups"
                [skills]="data.availableSkills"
                [teams]="data.availableTeams"
                [justSkills]="false"
                [multipleCsrEnabled]="false"
                [noFieldset]="true"
                [preselectedCsrUuid]="originalSelectedCsrUuid"
                [preselectedSkillUuids]="originalSelectedSkillUuids"
                [preselectedGroupUuid]="originalSelectedGroupUuid"
                [preselectedTeamUuid]="originalSelectedTeamUuid"
              >
              </cng-appointment-target-form>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <div class="modal-footer modal-confirm">
      <button (click)="save()" class="button-confirm cng-ico_check" [disabled]="!isFormValid()">
        {{ 'agent:actions.validate' | translate }}
      </button>
      <button (click)="cancel()" class="button-cancel cng-ico_annuler">
        {{ 'agent:actions.cancel' | translate }}
      </button>
    </div>
  </div>
</div>
